import React from "react";
import PropTypes from "prop-types";
import { Autocomplete, TextField, Chip } from "@mui/material";

function ExamTypeSelect({ examTypes, form, setForm, errors }) {
  // Normalize form.exam_type_id to array
  const selectedIds = Array.isArray(form.exam_type_id)
    ? form.exam_type_id
    : form.exam_type_id
    ? form.exam_type_id.toString().split(",")
    : [];

  // Map selectedIds to option objects
  const selectedOptions = examTypes.filter((type) =>
    selectedIds.includes(type.exam_type_id.toString())
  );

  return (
    <Autocomplete
      multiple
      options={examTypes}
      getOptionLabel={(option) => option.exam_type_name}
      value={selectedOptions}
      isOptionEqualToValue={(option, value) =>
        option.exam_type_id.toString() === value.exam_type_id.toString()
      }
      onChange={(event, newValue) => {
        setForm({
          ...form,
          exam_type_id: newValue.map((v) => v.exam_type_id.toString()),
        });
      }}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            key={option.exam_type_id}
            label={option.exam_type_name}
            {...getTagProps({ index })}
            color="primary"
          />
        ))
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label="Exam Type"
          placeholder="Select Exam Types"
          error={!!errors.exam_type_id}
          helperText={errors.exam_type_id}
        />
      )}
    />
  );
}

ExamTypeSelect.propTypes = {
  examTypes: PropTypes.arrayOf(
    PropTypes.shape({
      exam_type_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      exam_type_name: PropTypes.string.isRequired,
    })
  ).isRequired,
  form: PropTypes.shape({
    exam_type_id: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
      PropTypes.string,
    ]),
  }).isRequired,
  setForm: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    exam_type_id: PropTypes.string,
  }),
};

export default ExamTypeSelect;
